(function () {
  'use strict';

  class MiaDonnaMegaMenu {
    constructor(root) {
      this.root = root;

      this.system = root.querySelector(
        '[data-md-mega-system]'
      );

      this.nav = root.querySelector(
        '[data-md-mega-nav]'
      );

      if (!this.system || !this.nav) {
        return;
      }

      this.triggers = this.nav.querySelectorAll(
        '[data-md-mega-trigger]'
      );

      this.drawers = this.system.querySelectorAll(
        '[data-md-mega-drawer]'
      );

      this.closeButtons = this.system.querySelectorAll(
        '[data-md-mega-close]'
      );

      this.overlay = this.system.querySelector(
        '[data-md-mega-overlay]'
      );

      this.activeId = null;

      this.openTimer = null;
      this.closeTimer = null;

      this.scrollTicking = false;

      this.bindEvents();

      /*
       * Calculate initial position
       */
      this.updateMegaMenuPosition();
    }


    /* =========================================================
       GET EXACT HEADER ELEMENT
    ========================================================= */

    getHeaderElement() {

      /*
       * Prefer actual header wrapper because the mega menu
       * should start exactly after the visible header.
       */

      const headerWrapper =
        this.root.querySelector(
          '.header-wrapper'
        );

      if (headerWrapper) {
        return headerWrapper;
      }


      /*
       * Fallback to sticky-header
       */

      const stickyHeader =
        this.root.querySelector(
          'sticky-header'
        );

      if (stickyHeader) {
        return stickyHeader;
      }


      /*
       * Final fallback
       */

      return this.root;
    }


    /* =========================================================
       UPDATE MEGA MENU POSITION
    ========================================================= */

    updateMegaMenuPosition() {

      if (!this.system) {
        return;
      }


      const header =
        this.getHeaderElement();

      if (!header) {
        return;
      }


      /*
       * Get exact visible header position
       */

      const rect =
        header.getBoundingClientRect();


      /*
       * Bottom position of header relative
       * to viewport.
       */

      let headerBottom =
        rect.bottom;


      /*
       * Prevent negative values
       */

      headerBottom =
        Math.max(
          0,
          Math.round(headerBottom)
        );


      /*
       * Store exact position in CSS variable.
       *
       * CSS:
       * top: var(--md-mega-top)
       */

      this.system.style.setProperty(
        '--md-mega-top',
        `${headerBottom}px`
      );


      /*
       * Also set height dynamically.
       *
       * This guarantees the drawer reaches
       * exactly to the bottom of viewport.
       */

      this.system.style.setProperty(
        '--md-mega-height',
        `calc(100vh - ${headerBottom}px)`
      );
    }


    /* =========================================================
       BIND EVENTS
    ========================================================= */

    bindEvents() {


      /* ---------------------------------------------
         OPEN ON HOVER
      --------------------------------------------- */

      this.triggers.forEach((trigger) => {

        trigger.addEventListener(
          'mouseenter',
          () => {

            this.clearTimers();

            /*
             * Update position immediately before opening
             */

            this.updateMegaMenuPosition();


            const id =
              trigger.getAttribute(
                'data-md-mega-trigger'
              );


            this.openTimer =
              setTimeout(() => {

                this.open(id);

              }, 40);

          }
        );


        trigger.addEventListener(
          'mouseleave',
          () => {

            this.startCloseTimer();

          }
        );

      });


      /* ---------------------------------------------
         DRAWER HOVER
      --------------------------------------------- */

      this.drawers.forEach((drawer) => {

        drawer.addEventListener(
          'mouseenter',
          () => {

            this.clearTimers();

            /*
             * Keep position correct while drawer
             * is being interacted with.
             */

            this.updateMegaMenuPosition();

          }
        );


        drawer.addEventListener(
          'mouseleave',
          () => {

            this.startCloseTimer();

          }
        );


        /* ---------------------------------------------
           CATEGORY HOVER
        --------------------------------------------- */

        drawer
          .querySelectorAll(
            '[data-md-mega-tab]'
          )
          .forEach((tab) => {


            /*
             * Hover category
             */

            tab.addEventListener(
              'mouseenter',
              () => {

                const panelId =
                  tab.getAttribute(
                    'data-md-mega-tab'
                  );


                this.activateTab(
                  drawer,
                  panelId
                );

              }
            );


            /*
             * Click category
             */

            tab.addEventListener(
              'click',
              () => {

                const panelId =
                  tab.getAttribute(
                    'data-md-mega-tab'
                  );


                this.activateTab(
                  drawer,
                  panelId
                );

              }
            );

          });

      });


      /* ---------------------------------------------
         CLOSE BUTTON
      --------------------------------------------- */

      this.closeButtons.forEach((button) => {

        button.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            this.close();

          }
        );

      });


      /* ---------------------------------------------
         OVERLAY
      --------------------------------------------- */

      if (this.overlay) {

        this.overlay.addEventListener(
          'click',
          () => {

            this.close();

          }
        );

      }


      /* ---------------------------------------------
         ESCAPE
      --------------------------------------------- */

      document.addEventListener(
        'keydown',
        (event) => {

          if (event.key === 'Escape') {

            this.close();

          }

        }
      );


      /* ---------------------------------------------
         RESIZE
      --------------------------------------------- */

      window.addEventListener(
        'resize',
        () => {

          /*
           * Close on mobile
           */

          if (window.innerWidth < 990) {

            this.close();

            return;

          }


          /*
           * Recalculate exact header bottom
           */

          this.updateMegaMenuPosition();

        }
      );


      /* ---------------------------------------------
         SCROLL
      --------------------------------------------- */

      window.addEventListener(
        'scroll',
        () => {

          /*
           * Only update while menu is open.
           */

          if (
            !this.system.classList.contains(
              'is-open'
            )
          ) {
            return;
          }


          /*
           * Avoid excessive calculations
           */

          if (this.scrollTicking) {
            return;
          }


          this.scrollTicking = true;


          window.requestAnimationFrame(
            () => {

              this.updateMegaMenuPosition();

              this.scrollTicking = false;

            }
          );

        },
        {
          passive: true
        }
      );

    }


    /* =========================================================
       CLEAR TIMERS
    ========================================================= */

    clearTimers() {

      clearTimeout(
        this.openTimer
      );

      clearTimeout(
        this.closeTimer
      );

      this.openTimer = null;
      this.closeTimer = null;

    }


    /* =========================================================
       START CLOSE TIMER
    ========================================================= */

    startCloseTimer() {

      this.clearTimers();


      this.closeTimer =
        setTimeout(() => {

          this.close();

        }, 250);

    }


    /* =========================================================
       OPEN
    ========================================================= */

    open(id) {

      this.clearTimers();


      if (!id) {
        return;
      }


      /*
       * IMPORTANT:
       * Calculate header bottom immediately before
       * opening the mega menu.
       */

      this.updateMegaMenuPosition();


      const drawer =
        this.system.querySelector(
          '[data-md-mega-drawer="' +
            id +
          '"]'
        );


      if (!drawer) {

        console.warn(
          'MiaDonna Mega Menu: drawer not found for',
          id
        );

        return;

      }


      /* ---------------------------------------------
         REMOVE PREVIOUS ACTIVE DRAWER
      --------------------------------------------- */

      this.drawers.forEach((item) => {

        item.classList.remove(
          'is-active'
        );

        item.setAttribute(
          'aria-hidden',
          'true'
        );

      });


      /* ---------------------------------------------
         REMOVE ACTIVE TRIGGER
      --------------------------------------------- */

      this.triggers.forEach((item) => {

        item.classList.remove(
          'is-active'
        );

      });


      /* ---------------------------------------------
         ACTIVE TRIGGER
      --------------------------------------------- */

      const trigger =
        this.nav.querySelector(
          '[data-md-mega-trigger="' +
            id +
          '"]'
        );


      if (trigger) {

        trigger.classList.add(
          'is-active'
        );

      }


      /* ---------------------------------------------
         ACTIVE DRAWER
      --------------------------------------------- */

      drawer.classList.add(
        'is-active'
      );

      drawer.setAttribute(
        'aria-hidden',
        'false'
      );


      /* ---------------------------------------------
         OPEN SYSTEM
      --------------------------------------------- */

      this.system.classList.add(
        'is-open'
      );

      this.system.setAttribute(
        'aria-hidden',
        'false'
      );


      this.activeId = id;


      /* ---------------------------------------------
         ACTIVATE FIRST CATEGORY
      --------------------------------------------- */

      this.activateFirstTab(
        drawer
      );


      /*
       * Final position calculation after opening.
       * This handles sticky header transitions.
       */

      requestAnimationFrame(
        () => {

          this.updateMegaMenuPosition();

        }
      );

    }


    /* =========================================================
       CLOSE
    ========================================================= */

    close() {

      this.clearTimers();


      this.system.classList.remove(
        'is-open'
      );

      this.system.setAttribute(
        'aria-hidden',
        'true'
      );


      /* ---------------------------------------------
         CLOSE ALL DRAWERS
      --------------------------------------------- */

      this.drawers.forEach((drawer) => {

        drawer.classList.remove(
          'is-active'
        );

        drawer.setAttribute(
          'aria-hidden',
          'true'
        );

      });


      /* ---------------------------------------------
         REMOVE ACTIVE TRIGGERS
      --------------------------------------------- */

      this.triggers.forEach((trigger) => {

        trigger.classList.remove(
          'is-active'
        );

      });


      this.activeId = null;

    }


    /* =========================================================
       ACTIVATE FIRST TAB
    ========================================================= */

    activateFirstTab(drawer) {

      const tabs =
        drawer.querySelectorAll(
          '[data-md-mega-tab]'
        );


      if (!tabs.length) {
        return;
      }


      let activeTab =
        drawer.querySelector(
          '[data-md-mega-tab].is-active'
        );


      if (!activeTab) {

        activeTab =
          tabs[0];

      }


      this.activateTab(
        drawer,
        activeTab.getAttribute(
          'data-md-mega-tab'
        )
      );

    }


    /* =========================================================
       ACTIVATE TAB
    ========================================================= */

    activateTab(
      drawer,
      panelId
    ) {

      if (!panelId) {
        return;
      }


      const tabs =
        drawer.querySelectorAll(
          '[data-md-mega-tab]'
        );


      const panels =
        drawer.querySelectorAll(
          '[data-md-mega-panel]'
        );


      /* ---------------------------------------------
         TABS
      --------------------------------------------- */

      tabs.forEach((tab) => {

        tab.classList.toggle(
          'is-active',
          tab.getAttribute(
            'data-md-mega-tab'
          ) === panelId
        );

      });


      /* ---------------------------------------------
         PANELS
      --------------------------------------------- */

      panels.forEach((panel) => {

        panel.classList.toggle(
          'is-active',
          panel.getAttribute(
            'data-md-mega-panel'
          ) === panelId
        );

      });

    }

  }


  /* =========================================================
     INITIALIZE MEGA MENUS
  ========================================================= */

  function initMegaMenus() {

    document
      .querySelectorAll(
        '[data-md-mega-system]'
      )
      .forEach((system) => {


        /* ---------------------------------------------
           PREVENT DUPLICATE INITIALIZATION
        --------------------------------------------- */

        if (
          system.dataset.mdMegaInitialized ===
          'true'
        ) {
          return;
        }


        system.dataset.mdMegaInitialized =
          'true';


        /*
         * System and nav are siblings,
         * so find closest header.
         */

        const header =
          system.closest(
            '.section-header'
          ) ||
          system.parentElement;


        if (!header) {
          return;
        }


        new MiaDonnaMegaMenu(
          header
        );

      });

  }


  /* =========================================================
     INITIAL LOAD
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initMegaMenus
    );

  } else {

    initMegaMenus();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    () => {

      setTimeout(
        initMegaMenus,
        50
      );

    }
  );


})();